const DOMAIN_SEGMENTS = -2;

export function getDomain(): string {
  return location.host
    .replace(/:\d+/, '')
    .split('.')
    .slice(DOMAIN_SEGMENTS)
    .join('.');
}
